import { cssClasses, type CSSPropertiesWithVar } from 'pkg/css/utils';

import * as css from './styles.css';

interface FooterProps extends React.HTMLAttributes<HTMLElement> {
	className?: string;
	alignItems?: 'start' | 'center' | 'end' | 'stretch';
	justifyContent?: 'normal' | 'start' | 'center' | 'end' | 'space-between';
	gridAutoColumns?: string;
	showTopBorder?: boolean;
}

export function Footer({
	children,
	alignItems = 'center',
	justifyContent = 'end',
	gridAutoColumns,
	showTopBorder = false,
	className,
	style,
	...rest
}: FooterProps) {
	const styles: CSSPropertiesWithVar = {
		'--align': alignItems,
		'--justify': justifyContent,
		'--grid-auto-columns': gridAutoColumns,
	};

	const finalStyles = { ...style, ...styles };

	return (
		<footer
			style={finalStyles}
			className={cssClasses(
				css.footer,
				className,
				showTopBorder && css.withTopBorder
			)}
			{...rest}>
			{children}
		</footer>
	);
}
